module.exports = __webpack_public_path__ + "static/media/dropdown.a664b342.svg";